var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26.4C13.0625 26.4 10.0238 24.64 8.25 22C8.29125 19.25 13.75 17.7375 16.5 17.7375C19.25 17.7375 24.7088 19.25 24.75 22C23.841 23.3536 22.6131 24.4628 21.1744 25.2301C19.7357 25.9974 18.1305 26.3992 16.5 26.4ZM16.5 6.875C17.594 6.875 18.6432 7.3096 19.4168 8.08319C20.1904 8.85677 20.625 9.90598 20.625 11C20.625 12.094 20.1904 13.1432 19.4168 13.9168C18.6432 14.6904 17.594 15.125 16.5 15.125C15.406 15.125 14.3568 14.6904 13.5832 13.9168C12.8096 13.1432 12.375 12.094 12.375 11C12.375 9.90598 12.8096 8.85677 13.5832 8.08319C14.3568 7.3096 15.406 6.875 16.5 6.875ZM16.5 2.75C14.6943 2.75 12.9063 3.10565 11.2381 3.79666C9.56988 4.48766 8.05409 5.50048 6.77728 6.77728C4.19866 9.35591 2.75 12.8533 2.75 16.5C2.75 20.1467 4.19866 23.6441 6.77728 26.2227C8.05409 27.4995 9.56988 28.5124 11.2381 29.2034C12.9063 29.8944 14.6943 30.25 16.5 30.25C20.1467 30.25 23.6441 28.8013 26.2227 26.2227C28.8013 23.6441 30.25 20.1467 30.25 16.5C30.25 8.89625 24.0625 2.75 16.5 2.75Z",
    fill: "#010048",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.4206b34535c2aefffa761105ae9d0187.svg";
export { ForwardRef as ReactComponent };